import useSWR from "swr";
import fetcher from "@adora/shared/utils/fetch";
import { RelativeUrl } from "@adora/shared/utils/environment";
import { Theme } from "@adora/shared/types/theme";

const useThemes = (brandId?: number | null) => {
  const { data } = useSWR<Theme[]>(brandId ? `${RelativeUrl}/themes?brand_id=${brandId}` : null, fetcher);

  return {
    themes: data
  };
};

export default useThemes;
